/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_CachingInputs */

const en_svchip_caching = /** @type {(inputs: Svchip_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caching`)
};

const ar_svchip_caching = /** @type {(inputs: Svchip_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التخزين المؤقت`)
};

const bn_svchip_caching = /** @type {(inputs: Svchip_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যাশিং`)
};

const de_svchip_caching = /** @type {(inputs: Svchip_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caching`)
};

const es_svchip_caching = /** @type {(inputs: Svchip_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento en caché`)
};

const fr_svchip_caching = /** @type {(inputs: Svchip_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en cache`)
};

const pt_svchip_caching = /** @type {(inputs: Svchip_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cache`)
};

const zh_svchip_caching = /** @type {(inputs: Svchip_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缓存`)
};

const tr_svchip_caching = /** @type {(inputs: Svchip_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önbelleğe Alma`)
};

const ru_svchip_caching = /** @type {(inputs: Svchip_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кэширование`)
};

const pl_svchip_caching = /** @type {(inputs: Svchip_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buforowanie`)
};

/**
* | output |
* | --- |
* | "Caching" |
*
* @param {Svchip_CachingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_caching = /** @type {((inputs?: Svchip_CachingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_CachingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_caching(inputs)
	if (locale === "bn") return bn_svchip_caching(inputs)
	if (locale === "de") return de_svchip_caching(inputs)
	if (locale === "es") return es_svchip_caching(inputs)
	if (locale === "fr") return fr_svchip_caching(inputs)
	if (locale === "pt") return pt_svchip_caching(inputs)
	if (locale === "zh") return zh_svchip_caching(inputs)
	if (locale === "tr") return tr_svchip_caching(inputs)
	if (locale === "ru") return ru_svchip_caching(inputs)
	if (locale === "pl") return pl_svchip_caching(inputs)
	return en_svchip_caching(inputs)
});